import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import tw from "twin.macro";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Slide1 from "../../images/img/Slide1.svg";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-8 lg:py-12`;

const TwoColumn = styled.div`
    ${tw`flex flex-col lg:flex-row items-center justify-between gap-12`}
`;

const LeftColumn = styled.div`
    ${tw`w-full lg:w-1/2 flex flex-col items-start`}
`;

const RightColumn = styled.div`
    ${tw`w-full lg:w-1/2 flex justify-center`}
`;

const Heading = tw.h1`
  text-3xl sm:text-5xl font-black leading-snug text-center lg:text-left mb-6
`;

const Paragraph = styled.p`
    ${tw`text-base xl:text-xl text-gray-700 mb-6 text-center lg:text-left`}
    max-width: 95%;
    line-height: 1.6;
`;

const Button = styled.button`
    ${tw`mt-2 px-6 py-3 bg-green-1002 text-white font-bold rounded-full transition duration-300`}
    cursor: pointer;
    &:hover {
        ${tw`bg-green-600`}
        transform: scale(1.05);
    }
`;

const Image = styled.img`
    ${tw`w-full max-w-lg rounded-md`}
    object-fit: cover;
`;

export default () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const auth = getAuth();

    // Отслеживаем состояние авторизации
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
        });

        return () => unsubscribe();
    }, [auth]);

    const handleGetAddressClick = () => {
        if (user) {
            navigate("/PersonalArea");
        } else {
            navigate("/Login");
        }
    };

    return (
        <Container>
            <Content>
                <TwoColumn>
                    <LeftColumn>
                        <Heading>{t("warehouse.heading")}</Heading>
                        <Paragraph>{t("warehouse.description")}</Paragraph>
                        <Button onClick={handleGetAddressClick}>{t("warehouse.button")}</Button>
                    </LeftColumn>
                    <RightColumn>
                        <Image src={Slide1} alt={t("warehouse.imageAlt")} />
                    </RightColumn>
                </TwoColumn>
            </Content>
        </Container>
    );
};
